<div class="root">
  <mat-progress-bar class="busy-progress" mode="indeterminate" [hidden]="!isNavigating"></mat-progress-bar>
  <div class="background">
    <img alt="background" src="/img/background.png">
  </div>
  <div class="container" dir="{{languageService.direction | async}}">

    <button (click)="exit()" class="exit">
      <svg class="desktop" fill="#092473" height="11" viewBox="0 0 11 11" width="11" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.392188 10.2772C0.652188 10.5372 0.993438 10.6678 1.33469 10.6678C1.67594 10.6678 2.01719 10.5372 2.27719 10.2772L5.33469 7.21969L8.39219 10.2772C8.65219 10.5372 8.99344 10.6678 9.33469 10.6678C9.67594 10.6678 10.0172 10.5372 10.2772 10.2772C10.7984 9.75594 10.7984 8.91344 10.2772 8.39156L7.21969 5.33406L10.2772 2.27656C10.7984 1.75531 10.7984 0.912813 10.2772 0.390938C9.75594 -0.130313 8.91344 -0.130313 8.39156 0.390938L5.33406 3.44844L2.27656 0.390938C1.75531 -0.130313 0.912813 -0.130313 0.390938 0.390938C-0.130313 0.912188 -0.130313 1.75469 0.390938 2.27656L3.44844 5.33406L0.390938 8.39156C-0.130313 8.91281 -0.130313 9.75531 0.390938 10.2772H0.392188Z"
          fill="#092473"/>
      </svg>
      <svg class="mobile" fill="none" height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.477914 12.524C0.794745 12.8408 1.21059 13 1.62643 13C2.04227 13 2.45811 12.8408 2.77494 12.524L6.50076 8.79805L10.2266 12.524C10.5434 12.8408 10.9593 13 11.3751 13C11.7909 13 12.2068 12.8408 12.5236 12.524C13.1588 11.8888 13.1588 10.8621 12.5236 10.2261L8.79779 6.50019L12.5236 2.77426C13.1588 2.13906 13.1588 1.11237 12.5236 0.476404C11.8884 -0.158801 10.8618 -0.158801 10.2258 0.476404L6.5 4.20233L2.77418 0.476404C2.139 -0.158801 1.11234 -0.158801 0.47639 0.476404C-0.158797 1.11161 -0.158797 2.1383 0.47639 2.77426L4.20221 6.50019L0.47639 10.2261C-0.158797 10.8613 -0.158797 11.888 0.47639 12.524H0.477914Z"
          fill="white"/>
      </svg>
    </button>

    <router-outlet></router-outlet>
  </div>

  <app-cookie-banner></app-cookie-banner>
</div>

